import http from 'axios'
import urls from './oktaUsers.urls'

export default {
  getOktaUser: ({ state, rootState, commit }, login) => {
    if (login) {
      commit('global/setShowLoadingSpinner', true, { root: true })
      return http
        .get(urls.lookupUser, { params: { login: login } })
        .then(response => {
          commit('setOktaUser', response.data)
          commit('global/setShowLoadingSpinner', false, { root: true })
        }).catch(response => {
          if (response.response.status === 404) {
            commit('setOktaUser', false)
          } else {
            commit('global/setShowErrorMessage', true, { root: true })
          }
          commit('global/setShowLoadingSpinner', false, { root: true })
        })
    } else {
      commit('setOktaUser', null)
    }
  },
  getOktaUserHistory: ({ state, rootState, commit }, userId) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.lookupUserHistory(userId))
      .then(response => {
        commit('setOktaUserHistory', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  deleteOktaUsersGroup: ({ state, rootState, commit, dispatch }, { userId, groupId }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.userToGroup(userId, groupId))
      .then(() => {
        dispatch('getOktaUser', userId)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  addOktaUsersGroup: ({ state, rootState, commit, dispatch }, { userId, groupId }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .put(urls.userToGroup(userId, groupId))
      .then(() => {
        dispatch('getOktaUser', userId)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  createUser: ({ state, rootState, commit, dispatch }, { email, firstName, lastName, groupId }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.createUser, null, { params: { email, firstName, lastName, groupId } })
      .then(() => {
        dispatch('getOktaUser', email)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  }
}
